import { render } from "./FirstTimer.vue?vue&type=template&id=21d164ab&scoped=true"
import script from "./FirstTimer.vue?vue&type=script&lang=js"
export * from "./FirstTimer.vue?vue&type=script&lang=js"

import "./FirstTimer.vue?vue&type=style&index=0&id=21d164ab&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d164ab"]])

export default __exports__